// useOnline — subscribes to the browser online/offline events so the
// OfflineBanner can react. Uses navigator.onLine for the initial
// state. In jsdom the event listeners are real but navigator.onLine
// defaults to true, which matches the production happy path; tests
// can dispatch window.dispatchEvent(new Event("offline")) to flip it.

import { useEffect, useState } from "react";

export function useOnline(): boolean {
  const [online, setOnline] = useState<boolean>(() =>
    typeof navigator === "undefined" ? true : navigator.onLine,
  );

  useEffect(() => {
    if (typeof window === "undefined") return;
    const up = () => setOnline(true);
    const down = () => setOnline(false);
    window.addEventListener("online", up);
    window.addEventListener("offline", down);
    return () => {
      window.removeEventListener("online", up);
      window.removeEventListener("offline", down);
    };
  }, []);

  return online;
}
